import { createStatusChipComponent, type StatusConfig } from './CliveStatusUtils';
import { CLIVE_STORE_STATUS_CONFIG, CliveStoreProcessingStatus } from './CliveStoreStatusChip';

// GQ (General Queue) Status Enum - extends store statuses with GQ-specific ones
export enum GQStatus {
  // Inherit base statuses
  PROCESSING = CliveStoreProcessingStatus.PROCESSING,
  ERROR = CliveStoreProcessingStatus.ERROR,
  SUCCESS = CliveStoreProcessingStatus.SUCCESS,
  // Add GQ-specific statuses
  CLAIM_UPDATE = 'claim_update',
  NEW_FNOL = 'new_fnol',
}

// GQ config: Inherit base + add extensions directly
const GQ_STATUS_CONFIG: StatusConfig<GQStatus> = {
  ...CLIVE_STORE_STATUS_CONFIG, // Inherit: processing, error, success
  [GQStatus.CLAIM_UPDATE]: { iconType: 'happy' as const, content: 'Claim Update' },
  [GQStatus.NEW_FNOL]: { iconType: 'happy' as const, content: 'New FNOL' },
} as const;

// Create the GQ status chip component
export const GQStatusChip = createStatusChipComponent(GQ_STATUS_CONFIG, Object.values(GQStatus) as readonly GQStatus[]);
GQStatusChip.displayName = 'GQStatusChip';
